export const PRIVILEGE_PM = "PM";
export const PRIVILEGE_SUB_PM = "SUB_PM";
export const PRIVILEGE_CREATOR = "CREATOR";
export const PRIVILEGE_MEMBER = "MEMBER";
